import { render, staticRenderFns } from "./CapitalRecord.vue?vue&type=template&id=5c3fcf74&scoped=true"
import script from "./CapitalRecord.vue?vue&type=script&lang=js"
export * from "./CapitalRecord.vue?vue&type=script&lang=js"
import style0 from "./CapitalRecord.vue?vue&type=style&index=0&id=5c3fcf74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3fcf74",
  null
  
)

export default component.exports